import { Box, Typography } from '@mui/material';

export const AuthErrorBox = ({ message }: { message: string }) => {
  function createMarkup() {
    return { __html: message };
  }
  return (
    <>
      {message && (
        <Box
          sx={({ palette }) => ({
            padding: '15px',
            borderRadius: '4px',
            backgroundColor: palette.red.light,
            border: `1px solid ${palette.grey[600]}`,
          })}
        >
          <Typography
            sx={{ color: ({ palette }) => palette.red.main }}
            dangerouslySetInnerHTML={createMarkup()}
          />
        </Box>
      )}
    </>
  );
};
